import React, { useEffect, useState, useCallback } from 'react';
import { formatISO, fromUnixTime } from 'date-fns';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import { instance } from '../../services/api';

interface IChartProps {
  chartName: string;
  endpoint: string;
}

interface IData {
  time: number;
  transactions: number;
  formattedTime: string;
}

const Chart: React.FC<IChartProps> = ({ chartName, endpoint }) => {
  const [data, setData] = useState<IData[]>([]);
  const [rangeVariation, setRangeVariation] = useState(0);
  const [callback, setCallback] = useState(false);
  const [nTransactions, setNTransactions] = useState(1);

  const setRange = useCallback((values) => {
    const transactions = values.map((value: IData) => value.transactions);
    const maxValue = Math.max(...transactions);
    setRangeVariation(Math.ceil(maxValue * 0.3));
  }, []);

  const getFormattedDate = useCallback((values) => {
    const newData = values;
    newData.forEach((_: IData, idx: number) => {
      const [formattedTime] = formatISO(fromUnixTime(newData[idx].time), {
        representation: 'time',
      }).split('-');

      newData[idx].formattedTime = formattedTime;
    });

    setData(newData);
  }, []);

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const values = [];
      const len = res.data.length;

      for (let i = 0; i < 10; i++) {
        // const n = Math.floor(Math.random() * 20) - 10;
        // values.push({transactions: nTransactions+n, time: new Date().getTime()+i*1000});
        try {
          const value =
            len - i - 1 >= 0
              ? res.data[len - i - 1].result
              : res.data[0].result;
          values.push({
            transactions: value,
            time: new Date().getTime() + i * 1000,
          });
        } catch {
          // we must fix this
        }
      }
      setRange(values);
      getFormattedDate(values);
      setNTransactions(nTransactions + 1);
      setTimeout(() => setCallback(!callback), 7000);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartName, setRange, getFormattedDate, callback, endpoint]);

  return (
    <>
      <ResponsiveContainer width="99%" height={300}>
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="formattedTime" />
          <YAxis
            allowDecimals={false}
            dataKey="transactions"
            domain={[
              `dataMin - ${rangeVariation}`,
              `dataMax + ${rangeVariation}`,
            ]}
          />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="transactions"
            strokeWidth="2"
            dot={false}
            stroke="#82ca9d"
          />
        </LineChart>
      </ResponsiveContainer>
      <strong style={{ color: 'gray ', marginLeft: '25px' }}>
        {chartName}
      </strong>
    </>
  );
};

export default Chart;
